// extracted by mini-css-extract-plugin
module.exports = {"expando":"AnchoredPortal_expando__3vsW7"};